function setVariant(id) {
  var priceEls = document.getElementsByClassName("ProductForm__pill--price");
  for (var i = 0; i < priceEls.length; i++) {
    priceEls[i].style.display = "none";
  }
  document.getElementById("price-" + id).style.display = "inline-block";
  document.getElementById("buy-button").disabled = false;
}

function handleVariantChange(evt) {
  const variantId = evt.target.value;
  window.location.hash = variantId;
  setVariant(variantId);
}

function onWindowLoad() {
  var variantSelector = document.getElementById("variant-selector");
  if (variantSelector) {
    variantSelector.addEventListener("change", handleVariantChange);
    setVariant(variantSelector.value);
  } else {
    document.getElementsByClassName(
      "ProductForm__pill--price"
    )[0].style.display = "inline-block";
  }
}

window.onload = onWindowLoad;
